/** Read image file as data URL for logo/profile upload (max ~2.5 MB). */
export function fileToImageDataUrl(file, maxBytes = 2_500_000) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith('image/')) {
      reject(new Error('Please choose an image file (JPG, PNG, or WebP).'));
      return;
    }
    if (file.size > maxBytes) {
      reject(new Error('Image is too large. Use a file under 2.5 MB.'));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read image.'));
    reader.readAsDataURL(file);
  });
}
